import { render, staticRenderFns } from "./VehiclesHeader.vue?vue&type=template&id=2688bb24&"
import script from "./VehiclesHeader.vue?vue&type=script&lang=js&"
export * from "./VehiclesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports